module.exports = __webpack_public_path__ + "img/resource03.8f70234f.png";